export default __webpack_public_path__ + "static/media/mobile-home-page-banner.8622a477.png";